var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",on:{"click":_vm.register}},[_c('div',{staticClass:"button"},[_vm._v("\n    "+_vm._s(_vm.$l.clickAlreadyRegistered)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }